import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { triangle } from "../../assets/images"
import "./Accordion.scss"
import classNames from "classnames"

interface AccordionProps {
  title: string
  description: string
  isFirst?: boolean
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  description,
  isFirst,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={classNames("accordion", { "accordion--first": isFirst })}>
      <button
        className="accordion__header"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="accordion__title">{title}</span>
        <div className="accordion__chevron-container">
          <motion.img
            src={triangle}
            alt=""
            className="accordion__chevron"
            animate={{ rotate: isOpen ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          />
        </div>
      </button>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            className="accordion__content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto" },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            {description.split("\n\n").map((paragraph, index) => (
              <p key={index} className="accordion__description">
                {paragraph}
              </p>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
